import { Download } from 'lucide-react'
import { useState } from 'react'

import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar
} from '@/components/ui/sidebar'

import { IosInstallSheet } from './ios-install-sheet'
import { useInstallPrompt } from './use-install-prompt'

export function InstallSidebarRow() {
  const { platform, dismissed, install } = useInstallPrompt()
  const { isMobile, setOpenMobile } = useSidebar()
  const [iosOpen, setIosOpen] = useState(false)

  if (platform === 'none' || dismissed) return null

  function handleClick() {
    if (platform === 'ios') {
      /* the row lives inside the drawer on phones, so closing it would unmount
       * the walkthrough too. the sheet stacks on top instead. */
      setIosOpen(true)
      return
    }
    if (isMobile) setOpenMobile(false)
    void install()
  }

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton tooltip='Install app' onClick={handleClick}>
          <Download />
          <span>Install app</span>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <IosInstallSheet open={iosOpen} onOpenChange={setIosOpen} />
    </SidebarMenu>
  )
}
